import { useApi } from "../../hooks/useApi";
import { doctorService } from "../../services/doctors";
import { SecretaryUpsertResponse, SecretaryDeleteResponse, SecretaryListResponse } from "../../types/secretary.types";
import { useSession } from "../../context/SessionContext";
import { SUCCESS_MESSAGES } from "../../i18n/success.pt-BR";

export function useSecretaries() {
  const { metadata } = useSession();

  const addApi    = useApi<SecretaryUpsertResponse>();
  const deleteApi = useApi<SecretaryDeleteResponse>();
  const listApi   = useApi<SecretaryListResponse>();

  const addSecretaries = async (emails: string[]) => {
    if (!metadata.email) return null;

    return addApi.request(
      () => doctorService.addSecretaries(addApi.apiFetch, metadata.email!, { emails }),
      { successMessage: SUCCESS_MESSAGES.secretaryAdded },
    );
  };

  const deleteSecretary = async (secretaryEmail: string) => {
    if (!metadata.email) return null;

    return deleteApi.request(
      () => doctorService.deleteSecretary(deleteApi.apiFetch, metadata.email!, secretaryEmail),
      { successMessage: SUCCESS_MESSAGES.secretaryRemoved },
    );
  };

  const listSecretaries = async () => {
    if (!metadata.email) return null;

    return listApi.request(
      () => doctorService.listSecretaries(listApi.apiFetch, metadata.email!),
    );
  };

  const loading = addApi.loading || deleteApi.loading || listApi.loading;
  const error   = addApi.error ?? deleteApi.error ?? listApi.error;

  return { addSecretaries, deleteSecretary, listSecretaries, loading, error };
}